<template>
    <v-dialog v-model="editorShownTraining" width="850" persistent>
        <!-- Begin:v-card:Mode:update -------------------------------------- -->
        <v-card v-if="editorMode === 'update'" style="border: 2px solid orange;">
            <!-- >>> Card Title -------------------------------------------- -->
            <v-card-title class="blue-grey lighten-1 pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                <i style="font-size:20px; color: #ffffff;" class="b-fa b-fa-graduation-cap"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }} - Multiple ({{ editorMode.toUpperCase() }})
            </v-card-title>
            <!-- <<< Card Title -------------------------------------------- -->


            <!-- >>> Selected Trainings List ------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px; margin-bottom: 0px;"><i style="font-size:15px; color: orange; padding-right: 10px;" class="b-fa b-fa-user"></i><strong>Choose your Employees/Trainings:</strong></div>
            <selected-trainings-list v-model="employees" v-if="editorShownTraining" />
            <!-- <<< Selected Trainings List ------------------------------- -->


            <v-divider style="margin-top: 20px;"></v-divider>


            <!-- >>> Build Training ---------------------------------------- -->
            <v-stepper v-model="e6" non-linear>
                <v-stepper-header style="background-color: #78909c !important; color: #ffffff !important;" class="sticky">
                    <v-stepper-step editable step="1">Training Types</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step editable step="2">Training Dates</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="3" editable>Training Active & Airport</v-stepper-step>
                </v-stepper-header>

                <v-stepper-content step="1" style="margin: 20px;">
                    <v-row>
                        <v-col cols="6" class="biggerHeight">
                            <trainings-combo v-model="nameTraining" label="Select Training:" v-if="editorShownTraining" />
                        </v-col>
                        <!-- <v-col cols="6" class="biggerHeight">
                            <yesno-combo v-model="unlimited" label="Unlimited:" v-if="editorShownTraining" />
                        </v-col> -->
                    </v-row>

                    <!-- >>> validationMonths, validationDays, validationDate -->
                    <!-- <v-row>
                        <v-col cols="6" class="biggerHeight">
                            <input-field v-model="validationMonths" label="Validation (months):" />
                        </v-col>

                        <v-col cols="6" class="biggerHeight">
                            <input-field v-model="validationDays" label="Validation (days):" />
                        </v-col>
                    </v-row> -->

                    <datetime v-model="validationDate" label="Validation until" disabled="false" disabledTime="true" ref="validationDate" />
                    <!-- <<< validationMonths, validationDays, validationDate -->
                </v-stepper-content>

                <v-stepper-content step="2" style="margin: 20px;">
                    <!-- >>> Date Times -->
                    <datetime v-model="lastCheck" label="LastCheck" disabled="false" disabledTime="true" ref="lastCheck" style="padding-top: 25px !important;" />

                    <datetime v-model="startDate" label="Next Check - start" disabled="false" disabledTime="false" ref="startTimer" style="padding-top: 25px !important;" />
                    <datetime v-model="endDate" label="Next Check - end" disabled="false" disabledTime="false" ref="endTimer" />
                    <!-- <<< Date Times -->
                </v-stepper-content>

                <v-stepper-content step="3" style="margin: 20px;">
                    <v-card-text class="pt-5" style="position: relative;">
                        <v-row>
                            <v-col cols="6" class="">
                                <airports-combo v-model="codeAptFrom" label="Training Arprt:" />
                            </v-col>
                            <v-col cols="6" class="">
                                <yesno-combo v-model="activated" label="Active Trainer?" />
                            </v-col>
                        </v-row>

                        <!-- >>> Training Notes -->
                        <comment-textarea v-model="notes" label="Notes:" maxlength="300" />
                        <!-- <<< Training Notes -->
                    </v-card-text>
                </v-stepper-content>
            </v-stepper>
            <!-- <<< Build Training ---------------------------------------- -->


            <v-divider></v-divider>


            <!-- >>> Card Actions ------------------------------------------ -->
            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="onClose_TrainingsDialog">Close</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_Update_Training">Save</v-btn>
            </v-card-actions>
            <!-- <<< Card Actions ------------------------------------------ -->
        </v-card>
        <!-- End:v-card:Mode:update ---------------------------------------- -->



        <!-- Begin:v-card:Mode:create -------------------------------------- -->
        <v-card v-if="editorMode === 'create'" style="border: 2px solid orange;">
            <!-- >>> Card Title -------------------------------------------- -->
            <v-card-title class="blue-grey lighten-1 pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                <i style="font-size:20px; color: #ffffff;" class="b-fa b-fa-graduation-cap"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }} - Multiple ({{ editorMode.toUpperCase() }})
            </v-card-title>
            <!-- <<< Card Title -------------------------------------------- -->


            <!-- >>> Selected Employees List ------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px; margin-bottom: 0px;"><i style="font-size:15px; color: orange; padding-right: 10px;" class="b-fa b-fa-user"></i><strong>Choose your Employees:</strong></div>
            <selected-employees-list v-model="employees" v-if="editorShownTraining" />
            <!-- <<< Selected Employees List ------------------------------- -->


            <v-divider style="margin-top: 20px;"></v-divider>


            <!-- >>> Build Training ---------------------------------------- -->
            <v-stepper v-model="e6" non-linear>
                <v-stepper-header style="background-color: #78909c !important; color: #ffffff !important;" class="sticky">
                    <v-stepper-step editable step="1">Training Types</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step editable step="2">Training Dates</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="3" editable>Training Active & Airport</v-stepper-step>
                </v-stepper-header>

                <v-stepper-content step="1" style="margin: 20px;">
                    <v-row>
                        <v-col cols="6" class="biggerHeight">
                            <trainings-combo v-model="nameTraining" label="Select Training:" v-if="editorShownTraining" />
                        </v-col>
                        <!-- <v-col cols="6" class="biggerHeight">
                            <yesno-combo v-model="unlimited" label="Unlimited:" v-if="editorShownTraining" />
                        </v-col> -->
                    </v-row>

                    <!-- >>> validationMonths, validationDays, validationDate -->
                    <!-- <v-row>
                        <v-col cols="6" class="biggerHeight">
                            <input-field v-model="validationMonths" label="Validation (months):" />
                        </v-col>

                        <v-col cols="6" class="biggerHeight">
                            <input-field v-model="validationDays" label="Validation (days):" />
                        </v-col>
                    </v-row> -->

                    <datetime v-model="validationDate" label="Validation until" disabled="false" disabledTime="true" ref="validationDate" />
                    <!-- <<< validationMonths, validationDays, validationDate -->
                </v-stepper-content>

                <v-stepper-content step="2" style="margin: 20px;">
                    <!-- >>> Date Times -->
                    <datetime v-model="lastCheck" label="LastCheck" disabled="false" disabledTime="true" ref="lastCheck" style="padding-top: 25px !important;" />

                    <datetime v-model="startDate" label="Next Check - start" disabled="false" disabledTime="false" ref="startTimer" style="padding-top: 25px !important;" />
                    <datetime v-model="endDate" label="Next Check - end" disabled="false" disabledTime="false" ref="endTimer" />
                    <!-- <<< Date Times -->
                </v-stepper-content>

                <v-stepper-content step="3" style="margin: 20px;">
                    <v-card-text class="pt-5" style="position: relative;">
                        <v-row>
                            <v-col cols="6" class="">
                                <airports-combo v-model="codeAptFrom" label="Training Arprt:" />
                            </v-col>
                            <v-col cols="6" class="">
                                <yesno-combo v-model="activated" label="Active Trainer?" />
                            </v-col>
                        </v-row>

                        <!-- >>> Training Notes -->
                        <comment-textarea v-model="notes" label="Notes:" maxlength="300" />
                        <!-- <<< Training Notes -->
                    </v-card-text>
                </v-stepper-content>
            </v-stepper>
            <!-- <<< Build Training ---------------------------------------- -->


            <v-divider></v-divider>


            <!-- >>> Card Actions ------------------------------------------ -->
            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="onClose_TrainingsDialog">Close</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_Create_Training">Save</v-btn>
            </v-card-actions>
            <!-- <<< Card Actions ------------------------------------------ -->
        </v-card>
        <!-- End:v-card:Mode:create ---------------------------------------- -->
    </v-dialog>
</template>

<script>
    import Vue from 'vue';

    import AirportsCombo from '../../AirportsCombo.vue';
    import TrainingsCombo from '../../TrainingsCombo.vue';
    import YesnoCombo from '../../YesnoCombo.vue';
    import InputField from '../../InputField.vue';
    import Datetime from '../../DateTime.vue';
    import CommentTextarea from '../../CommentTextarea.vue';
    import SelectedEmployeesList from '../../SelectedEmployeesList.vue';
    import SelectedTrainingsList from '../../SelectedTrainingsList.vue';

    import { mapGetters, mapActions } from 'vuex';
    import { eventBus } from '../../../../../../../main';
    import moment from 'moment';


    export default {
        name  : 'event-editor-training',

        /* >>> *************************************************************** / /* Props */
        props : {

            value           : [ Boolean, Object ],                              // editorShownTraining
            eventStore      : Object,                                           // 'update'
            resourceId      : [ String, Number ],                               // 'update'
            eventRecord     : Object,                                           // 'update'
            resourceRecord  : Object,                                           // 'create'
            addDate         : Date,                                             // 'create'
            eventName       : String,                                           // 'update', 'create'
            editorMode      : String,                                           // 'update', 'create'

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components : {

            SelectedEmployeesList,
            SelectedTrainingsList,

            AirportsCombo,
            YesnoCombo,
            InputField,
            Datetime,
            CommentTextarea,
            TrainingsCombo,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({

            // >>> ------------------------------
            e6                  : 1,
            // >>> ------------------------------
            employees           : [],
            startDate           : null,
            endDate             : null,
            lastCheck           : null,
            validationDate      : null,
            validationDays      : null,
            validationMonths    : null,
            idAptFrom           : null,
            codeAptFrom         : null,
            activated           : null,
            unlimited           : null,
            notes               : null,
            nameTraining        : null,

        }), // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch : {

            agree(value) {

                if (value === true) {
                    // >>> ------------------ update
                    if (this.editorMode === 'update') {
                        this.onSave_Update_Training();
                    }

                    // >>> ------------------ create
                    if (this.editorMode === 'create') {
                        this.onSave_Create_Training();
                    }
                }

            }, // eo function agree()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed : {

            ...mapGetters([
                'get_Trainings',
                'get_Airports',
                // 'get_selectedMultiEvents', // get: selected Events
                // 'get_selectedMultiResources', // get: selected Resources
                'get_shared_IsEditingInThePastAllowed'
            ]),


            /*******************************************************************
            * editorShownTraining()
            *
            * Desc:
            * Note: Distinguishes between editorMode: 'update', 'create'
            *
            */
            editorShownTraining: {

                /***************************************************************
                * get()
                *
                * Desc:
                * Note:
                */
                get() {

                    let me = this,
                        timestamp = null,
                        startDate = null,
                        endDate = null,
                        lastCheck = null,
                        validationDate = null,
                        resourceRecord = me.resourceRecord,
                        eventRecord = me.eventRecord;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/training/EventEditor.vue >>> editorShownTraining get');
                    if (true === me.value) {                                    // we're opening so initialize data

                        // >>> ------------------ update
                        if (this.editorMode === 'update') {
                            if (eventRecord) {
                                Object.assign(me, {
                                    eventName           : this.eventName,
                                    startDate           : new Date(eventRecord.startDate),
                                    endDate             : new Date(eventRecord.endDate),
                                    lastCheck           : new Date(eventRecord.trainingObject.lastCheckDate),
                                    validationDate      : new Date(eventRecord.trainingObject.validationDate),
                                    validationDays      : eventRecord.trainingObject.validationDays ? String(eventRecord.trainingObject.validationDays) : null,
                                    validationMonths    : eventRecord.trainingObject.validationMonths ? String(eventRecord.trainingObject.validationMonths) : null,
                                    sectors             : null,
                                    duration            : null,
                                    idAptFrom           : eventRecord.trainingObject.idAptFrom,
                                    codeAptFrom         : eventRecord.trainingObject.aptFromCode,
                                    activated           : eventRecord.trainingObject.activated,
                                    // unlimited           : eventRecord.trainingObject.unlimited,
                                    notes               : eventRecord.trainingObject.notes,
                                    nameTraining        : eventRecord.trainingObject.name,
                                });
                            }
                        }

                        // >>> ------------------ create
                        if (this.editorMode === 'create') {
                            if (resourceRecord) {
                                timestamp = new Date(this.addDate).setHours(0, 0, 0, 0);
                                startDate = new Date(timestamp);
                                timestamp = new Date(this.addDate).setHours(23, 59, 0, 0);
                                endDate = new Date(timestamp);
                                lastCheck = new Date(this.addDate);
                                validationDate = new Date(this.addDate);

                                Object.assign(me, {
                                    eventName           : this.eventName,
                                    startDate           : startDate,
                                    endDate             : endDate,
                                    lastCheck           : lastCheck,
                                    validationDate      : validationDate,
                                    validationDays      : null,
                                    validationMonths    : null,
                                    sectors             : null,
                                    duration            : null,
                                    idAptFrom           : null,
                                    codeAptFrom         : 'BER',                // prefilled
                                    activated           : false,                // prefilled
                                    // unlimited           : false,             // prefilled
                                    notes               : null,
                                    nameTraining        : null,
                                });
                            }
                        }

                    } else if (false === me.value) {                            // we're closing so fire close event
                        // this.$emit('close'); // Needed?
                    }

                    // return always Boolean
                    return !!this.value;

                }, // eo editorShownTraining get

                /***************************************************************
                * set()
                *
                * Desc:
                * Note: only runs on close.
                */
                set(value) {

                    let me = this;;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/training/EventEditor.vue >>> editorShownTraining set');
                    this.$emit('input', value);

                } // eo editorShownTraining set

            } // eo function editorShownTraining()

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_create_Multiple_Trainings', // Call: Create Multiple Trainings,
                'actn_update_Multiple_Trainings', // Call: Update Multiple Trainings,
                'actn_set_SelectedMultiEvents',
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSave_Update_Training()
            *
            * Desc: 'Update Training' - Call.
            * Note: Agree in Dialog calls this Function again.
            * Note: Check if edit in past is allowed.
            *
            */
            onSave_Update_Training: function(){

                let me = this,
                    singleParamObject = {},
                    params = {
                        trainings : []
                    };


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/training/EventEditor.vue >>> onSave_Update_Training');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [me.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                this.employees.forEach(employee => {
                    singleParamObject = {
                        id                  : employee.originalId,
                        idResource          : null,
                        idResources         : [employee.resourceId],

                        idTrainingCheck     : me.get_TrainingId(this.nameTraining),
                        duration            : null,
                        nextCheckStartDate  : moment(me.startDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                        nextCheckEndDate    : moment(me.endDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                        idAptFrom           : me.get_AirportId(me.codeAptFrom),
                        idAptTo             : me.get_AirportId(me.codeAptFrom),
                        activated           : this.activated,
                        lastCheckDate       : moment(me.lastCheck).format('YYYY-MM-DDTHH:mm:ss+0000'),
                        notes               : this.notes,
                        sectors             : null,
                        // unlimited           : this.unlimited,
                        validationDate      : moment(me.validationDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                        validationDays      : this.validationDays ? Number(this.validationDays) : null,
                        validationMonths    : this.validationMonths ? Number(this.validationMonths) : null,
                        flightTime          : true,
                    };
                    params.trainings.push(singleParamObject);
                });

                if (this.validateParams_Update(params) === true) {
                    this.actn_update_Multiple_Trainings(params);
                }

            }, // eo function onSave_Update_Training()


            /*******************************************************************
            * onSave_Create_Training()
            *
            * Desc: 'Create Training' - Call.
            * Note:
            * Note: Check if edit in past is allowed.
            *
            */
            onSave_Create_Training: function(){

                let me = this,
                    params = {};


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/training/EventEditor.vue >>> onSave_Create_Training');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [me.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                params = {
                    id                  : null,
                    idResource          : null,
                    idResources         : this.employees,

                    idTrainingCheck     : me.get_TrainingId(this.nameTraining),
                    duration            : null,
                    nextCheckStartDate  : moment(me.startDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    nextCheckEndDate    : moment(me.endDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    idAptFrom           : me.get_AirportId(me.codeAptFrom),
                    idAptTo             : me.get_AirportId(me.codeAptFrom),
                    activated           : this.activated,
                    lastCheckDate       : moment(me.lastCheck).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    notes               : this.notes,
                    sectors             : null,
                    // unlimited           : this.unlimited,
                    validationDate      : moment(me.validationDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    validationDays      : this.validationDays ? Number(this.validationDays) : null,
                    validationMonths    : this.validationMonths ? Number(this.validationMonths) : null,
                    flightTime          : true,
                };

                if (this.validateParams_Create(params) === true) {
                    this.actn_create_Multiple_Trainings(params);
                    this.actn_set_SelectedMultiEvents([]); // send empty Array
                }

            }, // eo function onSave_Create_Training()


            /*******************************************************************
            * onClose_TrainingsDialog()
            *
            * Desc: Close Trainings Dialog.
            * Note:
            *
            */
            onClose_TrainingsDialog: function(){

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/training/EventEditor.vue >>> onClose_TrainingsDialog');
                this.actn_set_SelectedMultiEvents([]); // send empty Array
                me.editorShownTraining = false;

                eventBus.$emit('schedulerdeselectall'); // #401

            }, // eo function onClose_TrainingsDialog()




            /*******************************************************************
            * Validators:
            *******************************************************************/
            /*******************************************************************
            * validateParams_Update()
            *
            * Desc: Validate Params before Update.
            * Note:
            *
            * @param {Object} params (Params we want to send)
            */
            validateParams_Update: function(params) {

                let me = this,
                    startDate = null,
                    endDate = null,
                    a = null,
                    b = null,
                    diffInHours = null,
                    valid = false;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/training/EventEditor.vue >>> validateParams_Update');
                // >>> -------------------------- 'resources?'                   // Check 1
                if (params.trainings.length === 0) {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Validation: Ressources is a required field.'
                    });
                    valid = false;
                } else {
                    valid = true;
                }
                // <<< --------------------------

                // >>> -------------------------- 'idTrainingCheck?'            // Check 3
                if (valid === true) {  // still valid
                    if (params.trainings[0].idTrainingCheck === null || params.trainings[0].idTrainingCheck === undefined) {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: "Validation: 'Select Training' is mandatory."
                        });
                        valid = false;
                    } else {
                        valid = true;
                    }
                }
                // <<< --------------------------

                // >>> -------------------------- 'startDate bef endDate?'      // Check 2
                if (valid === true) {  // still valid
                    startDate = moment(params.trainings[0].nextCheckStartDate);
                    endDate = moment(params.trainings[0].nextCheckEndDate);
                    if (endDate.isBefore(startDate)) {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: 'Validation: EndDate must be after StartDate.'
                        });
                        valid = false;
                    } else {
                        valid = true;
                    }
                }
                // <<< --------------------------

                // >>> -------------------------- 'idAptFrom?'                  // Check 3
                if (valid === true) {  // still valid
                    if (params.trainings[0] === null || params.trainings[0].idAptFrom === undefined) {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: "Validation: 'Training Airport' is mandatory."
                        });
                        valid = false;
                    } else {
                        valid = true;
                    }
                }
                // <<< --------------------------

                // >>> -------------------------- 'unlimited?'                  // Check 4
                // if unlimited false then Validation Month or Days Mandatory field
                // if unlimited true then no validation may be entered
                // if (valid === true) {  // still valid
                //     if (params.trainings[0].unlimited === false) {
                //         if ((params.trainings[0].validationDays === null) && (params.trainings[0].validationMonths === null)) {
                //             Vue.prototype.$toasted.global.sdr_app_error({
                //                 message: "Validation: 'Unlimited is false:' Validation Days or Months are mandatory then."
                //             });
                //             valid = false;
                //         } else {
                //             valid = true;
                //         }
                //     }
                // }

                // if (valid === true) {  // still valid
                //     if (params.trainings[0].unlimited === true) {
                //         if ((params.trainings[0].validationDays !== null) || (params.trainings[0].validationMonths !== null)) {
                //             Vue.prototype.$toasted.global.sdr_app_error({
                //                 message: "Validation: 'Unlimited is true:' Validation Days or Months are not allowed then."
                //             });
                //             valid = false;
                //         } else {
                //             valid = true;
                //         }
                //     }
                // }
                // <<< --------------------------


                return valid;

            }, // eo function validateParams_Update()


            /*******************************************************************
            * validateParams_Create()
            *
            * Desc: Validate Params before Create.
            * Note:
            *
            * @param {Object} params (Params we want to send)
            */
            validateParams_Create: function(params) {

                let me = this,
                    startDate = null,
                    endDate = null,
                    a = null,
                    b = null,
                    diffInHours = null,
                    valid = false;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/training/EventEditor.vue >>> validateParams_Create');
                // >>> -------------------------- 'resources?'                   // Check 1
                if (params.idResources === null || params.idResources === undefined || params.idResources.length === 0) {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Validation: Ressources is a required field.'
                    });
                    valid = false;
                } else {
                    valid = true;
                }
                // <<< --------------------------

                // >>> -------------------------- 'idTrainingCheck?'            // Check 3
                if (valid === true) {  // still valid
                    if (params.idTrainingCheck === null || params.idTrainingCheck === undefined) {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: "Validation: 'Select Training' is mandatory."
                        });
                        valid = false;
                    } else {
                        valid = true;
                    }
                }
                // <<< --------------------------

                // >>> -------------------------- 'startDate bef endDate?'      // Check 2
                if (valid === true) {  // still valid
                    startDate = moment(params.nextCheckStartDate);
                    endDate = moment(params.nextCheckEndDate);
                    if (endDate.isBefore(startDate)) {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: 'Validation: EndDate must be after StartDate.'
                        });
                        valid = false;
                    } else {
                        valid = true;
                    }
                }
                // <<< --------------------------

                // >>> -------------------------- 'idAptFrom?'                  // Check 3
                if (valid === true) {  // still valid
                    if (params.idAptFrom === null || params.idAptFrom === undefined) {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: "Validation: 'Training Airport' is mandatory."
                        });
                        valid = false;
                    } else {
                        valid = true;
                    }
                }
                // <<< --------------------------

                // >>> -------------------------- 'unlimited?'                  // Check 4
                // if unlimited false then Validation Month or Days Mandatory field
                // if unlimited true then no validation may be entered
                // if (valid === true) {  // still valid
                //     if (params.unlimited === false) {
                //         if ((params.validationDays === null) && (params.validationMonths === null)) {
                //             Vue.prototype.$toasted.global.sdr_app_error({
                //                 message: "Validation: 'Unlimited is false:' Validation Days or Months are mandatory then."
                //             });
                //             valid = false;
                //         } else {
                //             valid = true;
                //         }
                //     }
                // }

                // if (valid === true) {  // still valid
                //     if (params.unlimited === true) {
                //         if ((params.validationDays !== null) || (params.validationMonths !== null)) {
                //             Vue.prototype.$toasted.global.sdr_app_error({
                //                 message: "Validation: 'Unlimited is true:' Validation Days or Months are not allowed then."
                //             });
                //             valid = false;
                //         } else {
                //             valid = true;
                //         }
                //     }
                // }
                // <<< --------------------------


                return valid;

            }, // eo function validateParams_Create()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * get_AirportId()
            *
            * Desc: Return Airports-Id.
            * Note:
            *
            */
            get_AirportId: function(code) {

                let me = this,
                    aptId = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/training/EventEditor.vue >>> get_AirportId');
                this.get_Airports.forEach((apt, i) => {
                    if (apt.aptCode === code) {
                        // this.idApt = apt.idAirport;
                        aptId = apt.idAirport;
                    }
                });


                return aptId;

            }, // eo function get_AirportId()


            /*******************************************************************
            * get_TrainingId()
            *
            * Desc: Returns Trainings-Id.
            * Note: 'code', 'name', 'id'
            *
            * @param {String}  nameTraining (Trainings Name)
            */
            get_TrainingId: function(nameTraining) {

                let me = this,
                    trainingId = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/training/EventEditor.vue >>> get_TrainingId');
                this.get_Trainings.forEach((training, i) => {
                    if (training.name === nameTraining) {
                        trainingId = training.id;
                    }
                });


                return trainingId;

            }, // eo function get_TrainingId()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .smallerHeight {
        padding-top: 0px;
        padding-bottom: 0px;
    }

    .biggerHeight {
        padding-top: 20px;
        padding-bottom: 20px;
    }
</style>
